import { DeliveryModes, PractitionerTypes, FacilityTypes } from './schema'

export const minorProceduresServices = [
  {
    serviceId: 'PROC_001',
    serviceName: 'Suturing',
    category: 'Minor Procedures',
    specialty: null,
    subCategory: 'Wound Care',
    description: 'Minor wound closure using sutures for cuts and lacerations',
    cost: 350,
    durationMinutes: 30,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.HOME_VISIT],
    requiredPractitionerType: PractitionerTypes.GP,
    status: 'active',
    billingCode: 'PROC_SUTURE',
    billableItems: [
      {
        itemId: 'SUTURE_001',
        itemName: 'Suture kit',
        itemType: 'consumable'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.HOSPITAL],
    customisable: true,
    tags: ['suturing', 'wound', 'stitches'],
    displayOrder: 1
  },
  {
    serviceId: 'PROC_002',
    serviceName: 'Wound Care and Dressing',
    category: 'Minor Procedures',
    specialty: null,
    subCategory: 'Wound Care',
    description: 'Cleaning, assessment, and dressing of wounds',
    cost: 200,
    durationMinutes: 20,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.HOME_VISIT],
    requiredPractitionerType: PractitionerTypes.NURSE,
    status: 'active',
    billingCode: 'PROC_WOUND',
    billableItems: [
      {
        itemId: 'DRESS_001',
        itemName: 'Wound dressing kit',
        itemType: 'consumable'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.HOSPITAL],
    customisable: true,
    tags: ['wound', 'dressing', 'care'],
    displayOrder: 2
  },
  {
    serviceId: 'PROC_003',
    serviceName: 'Abscess Drainage',
    category: 'Minor Procedures',
    specialty: null,
    subCategory: 'Surgical Procedures',
    description: 'Incision and drainage of superficial abscesses',
    cost: 500,
    durationMinutes: 45,
    deliveryModes: [DeliveryModes.IN_PERSON],
    requiredPractitionerType: PractitionerTypes.GP,
    status: 'active',
    billingCode: 'PROC_ABSCESS',
    billableItems: [
      {
        itemId: 'DRAIN_001',
        itemName: 'Drainage kit',
        itemType: 'consumable'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.HOSPITAL],
    customisable: true,
    tags: ['abscess', 'drainage', 'surgical'],
    displayOrder: 3
  },
  {
    serviceId: 'PROC_004',
    serviceName: 'Skin Lesion Removal',
    category: 'Minor Procedures',
    specialty: 'Dermatology',
    subCategory: 'Dermatological Procedures',
    description: 'Removal of benign skin lesions, moles, and cysts',
    cost: 600,
    durationMinutes: 30,
    deliveryModes: [DeliveryModes.IN_PERSON],
    requiredPractitionerType: PractitionerTypes.GP,
    status: 'active',
    billingCode: 'PROC_LESION',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC],
    customisable: true,
    tags: ['lesion', 'removal', 'dermatology'],
    displayOrder: 4
  },
  {
    serviceId: 'PROC_005',
    serviceName: 'Joint Injection',
    category: 'Minor Procedures',
    specialty: 'Rheumatology',
    subCategory: 'Joint Care',
    description: 'Therapeutic injection into joints for pain and inflammation',
    cost: 450,
    durationMinutes: 20,
    deliveryModes: [DeliveryModes.IN_PERSON],
    requiredPractitionerType: PractitionerTypes.GP,
    status: 'active',
    billingCode: 'PROC_JOINT',
    billableItems: [
      {
        itemId: 'INJECT_001',
        itemName: 'Injection kit',
        itemType: 'consumable'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.HOSPITAL],
    customisable: true,
    tags: ['joint', 'injection', 'pain'],
    displayOrder: 5
  },
  {
    serviceId: 'PROC_006',
    serviceName: 'Ear Irrigation',
    category: 'Minor Procedures',
    specialty: null,
    subCategory: 'ENT Procedures',
    description: 'Ear wax removal and irrigation for blocked ears',
    cost: 180,
    durationMinutes: 15,
    deliveryModes: [DeliveryModes.IN_PERSON],
    requiredPractitionerType: PractitionerTypes.NURSE,
    status: 'active',
    billingCode: 'PROC_EAR',
    billableItems: [
      {
        itemId: 'EAR_001',
        itemName: 'Irrigation kit',
        itemType: 'consumable'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC],
    customisable: true,
    tags: ['ear', 'irrigation', 'wax'],
    displayOrder: 6
  }
]

export default minorProceduresServices
